import React from 'react';
import TeamUpgradeInfo from './TeamUpgradeInfo';
import { useLogout } from '../account/localLogout';
import useAppSelector from '../app/redux/useAppSelector';
import Badge from '../components/Badge';
import Menu, { MenuItem, MenuSeparator } from '../components/Menu';
import { MessageSupportMenuItem } from '../help/HelpMenu';
import giftIcon from '../icons/non-prefilled/16x16/gift.svg';
import keyIcon from '../icons/non-prefilled/16x16/key.svg';
import { InviteMenuItem } from '../organization/InviteButton';

const shouldShowNewUpdateBadge = true;

const TeamMenu = () => {
  const logout = useLogout({ includeRedirectQueryString: false });

  const isAdmin = useAppSelector(
    (state) => state.session.user.type === 'ADMIN',
  );

  const adminBadge = (
    <Badge
      color="blue"
      icon={<Badge.Icon>{keyIcon}</Badge.Icon>}
      inline={false}
    >
      ADMIN
    </Badge>
  );

  const newBadge = (
    <Badge
      color="pink"
      icon={<Badge.Icon>{giftIcon}</Badge.Icon>}
      inline={false}
    >
      NEW
    </Badge>
  );

  return (
    <Menu>
      {isAdmin && <TeamUpgradeInfo />}
      <MenuSeparator />
      <InviteMenuItem />
      <MenuItem to="/settings">Preferences</MenuItem>
      <MenuSeparator />
      {isAdmin && (
        <>
          <MenuItem to="/admin/appearance" right={adminBadge}>
            Team settings
          </MenuItem>
          <MenuItem to="/admin/teammates" right={adminBadge}>
            Teammates
          </MenuItem>
          <MenuItem to="/admin/insights" right={adminBadge}>
            Insights
          </MenuItem>
          <MenuSeparator />
        </>
      )}
      <MenuItem
        to="https://go.slab.com/product-updates"
        newTab
        right={shouldShowNewUpdateBadge && newBadge}
      >
        Product updates
      </MenuItem>
      <MenuItem to="https://go.slab.com/help-center" newTab>
        Help documentation
      </MenuItem>
      <MessageSupportMenuItem noIcon fallbackToEmail />
      <MenuSeparator />
      <MenuItem onClick={logout}>Log out</MenuItem>
    </Menu>
  );
};

export default TeamMenu;
